const MENUS = [
  {
    title: 'INICIAL',
    route: 'site.index',
  },
  {
    title: 'O CLUBE',
    path: '/club',
    children: [
      { title: 'Informações', route: 'club.index' },
      { title: 'Regulamento', route: 'club.regulation' },
      { title: 'Notícias', route: 'club.informatives' },
    ],
  },
  {
    title: 'MINHAS VENDAS',
    route: 'site.my-sales',
  },
  {
    title: 'TREINAMENTOS',
    route: 'site.trainings',
  },
  {
    title: 'CAMPANHAS',
    route: 'points.campaigns',
  },
  {
    title: 'OS PONTOS',
    path: '/points',
    children: [
      { title: 'Tabela de Pontos', route: 'points.index' },
      { title: 'Extrato', route: 'points.extract' },
    ],
  },
  {
    title: 'CONTATO',
	route: 'site.contact'
},
];

export default MENUS;
